export function serializeValue(values: Array<string | number> = []): string {
  return values.join(':::');
}

export function deserializeValue(value = ''): string[] {
  return value.split(':::');
}
